/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Role_Org_Admin8Inputs */

const en__field__enum_role_org_admin8 = /** @type {(inputs: _Field__Enum_Role_Org_Admin8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization admin`)
};

/** @type {(inputs: _Field__Enum_Role_Org_Admin8Inputs) => LocalizedString} */
const de__field__enum_role_org_admin8 = en__field__enum_role_org_admin8;

/**
* | output |
* | --- |
* | "Organization admin" |
*
* @param {_Field__Enum_Role_Org_Admin8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_role_org_admin8 = /** @type {((inputs?: _Field__Enum_Role_Org_Admin8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Role_Org_Admin8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_role_org_admin8(inputs)
	return de__field__enum_role_org_admin8(inputs)
});
export { _field__enum_role_org_admin8 as "_field__enum_role_ORG_ADMIN" }